import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to use optimism to achieve.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Are you a ‘glass half empty’ or a ‘glass half full’ kind of
                                                person?</p>


                                            <div className="border_subtitle">Can you see the positives in what
                                                you do?
                                            </div>
                                            <div className="paraspace"><p>Optimism has been defined as ‘an
                                                inclination to anticipate the best possible outcome’. How you
                                                see situations can have a profound effect on how you think you
                                                are going to be able to cope with
                                                challenges or take opportunities. The study below outlines some
                                                very good reasons to
                                                be optimistic.</p></div>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Is optimism the key to Olympic
                                                    success?
                                                </div>
                                                <p>In 1995, three researchers<a className="superscripttext"
                                                                                href="further_info.php?course=300"><sup>1</sup></a> illustrated
                                                    the power of optimism in a study of Olympic
                                                    medallists. They found that those athletes who achieved
                                                    silver medals were often less
                                                    happy than those who achieved bronze medals.</p>
                                                <p>This may seem counterintuitive – the higher an athlete places
                                                    in the medals table, the
                                                    happier we would assume them to be. However, the research
                                                    shows that a person’s actual
                                                    achievement often mattered less than how they perceived that
                                                    feat.</p>
                                                <p>Those who achieved second-place success appeared to base
                                                    their feelings on the context
                                                    of ‘failing to be the best’. However, those who achieved
                                                    third-place positions were more
                                                    likely to make downward comparisons, being pleased to have
                                                    achieved a medal position.</p>
                                                <div className="uiheading"><p>Interestingly, those athletes who
                                                    felt more satisfied with their position (i.e. the bronze
                                                    medallists) were, in turn, more motivated to maintain their
                                                    efforts and engage in further
                                                    training to sustain such feelings. That is to say, those
                                                    athletes who framed their achievement
                                                    in a positive manner – glass half full – were more likely to
                                                    succeed in the future compared
                                                    to those athletes who saw the result unfavourably – glass
                                                    half empty.</p>
                                                </div>
                                            </div>

                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}